import React from 'react';
import { iSspProviderContext } from './interfaces';

const CONTEXT: React.Context<iSspProviderContext> = React.createContext(
    {} as iSspProviderContext
);

export default CONTEXT;
